const CATEGORY_DEFINITIONS = [
  { value: 'beauty', slug: 'beauty', label: 'Beauty Services', icon: '💇' },
  { value: 'boutique', slug: 'boutique', label: 'Boutiques', icon: '👗' },
  { value: 'catering', slug: 'catering', label: 'Catering', icon: '🍲' },
  { value: 'child care', slug: 'child-care', label: 'Child Care', icon: '🧸' },
  { value: 'design', slug: 'design', label: 'Design Services', icon: '🎨' },
  { value: 'elderly care', slug: 'elderly-care', label: 'Elderly Care', icon: '🤝' },
  { value: 'electrical', slug: 'electrical', label: 'Electrical Services', icon: '⚡' },
  { value: 'foodtruck', slug: 'foodtruck', label: 'Food Trucks', icon: '🚚' },
  { value: 'gardening', slug: 'gardening', label: 'Gardening', icon: '🌿' },
  { value: 'groceries', slug: 'groceries', label: 'Grocery Stores', icon: '🛒' },
  { value: 'home help', slug: 'home-help', label: 'Home Help & Cleaning', icon: '🏠' },
  { value: 'it services', slug: 'it-services', label: 'IT Services', icon: '💻' },
  { value: 'jewelry', slug: 'jewelry', label: 'Jewelry', icon: '💎' },
  { value: 'kosher', slug: 'kosher', label: 'Kosher Places', icon: '🕍' },
  { value: 'photography', slug: 'photography', label: 'Photography', icon: '📸' },
  { value: 'plumbing', slug: 'plumbing', label: 'Plumbing', icon: '🔧' },
  { value: 'realtors', slug: 'realtors', label: 'Realtors', icon: '🏡' },
  { value: 'restaurants', slug: 'restaurants', label: 'Local Restaurants', icon: '🍽️' },
  { value: 'vegan', slug: 'vegan', label: 'Vegan Places', icon: '🌱' },
  /* --- values businesses actually use in the directory (added so
     their listings are reachable from the hub's category tiles) --- */
  { value: 'clothing', slug: 'clothing', label: 'Clothing', icon: '👕' },
  { value: 'marketing', slug: 'marketing', label: 'Marketing', icon: '📣' },
  { value: 'personal shopping', slug: 'personal-shopping', label: 'Personal Shopping', icon: '🛍️' },
  { value: 'cleaning services', slug: 'cleaning-services', label: 'Cleaning Services', icon: '🧹' },
  { value: 'salon', slug: 'salon', label: 'Salons', icon: '💈' },
  { value: 'flea market', slug: 'flea-market', label: 'Flea Markets', icon: '🏷️' },
  { value: 'coffee shop', slug: 'coffee-shop', label: 'Coffee Shops', icon: '☕' },
  { value: 'farmers market', slug: 'farmers-market', label: 'Farmers Markets', icon: '🥕' },
  { value: 'murals', slug: 'murals', label: 'Murals', icon: '🖌️' },
  { value: 'wreaths', slug: 'wreaths', label: 'Wreaths', icon: '🎀' },
  { value: 'toys', slug: 'toys', label: 'Toys', icon: '🪀' },
  { value: 'others', slug: 'others', label: 'Other Businesses', icon: '🏪' },
  { 
  value: 'leadership coaching',
  slug: 'leadership-coaching',
  label: 'Leadership Development & Coaching',
  icon: '🧭'
},
{
  value: 'corporate training',
  slug: 'corporate-training',
  label: 'Corporate Training Facilitation & Workshops',
  icon: '🏢'
},
{
  value: 'youth leadership',
  slug: 'youth-leadership',
  label: 'Youth, Student & Girls Confidence / Leadership Development',
  icon: '🌟'
},
];

const safelyDecode = (value) => {
  try {
    return decodeURIComponent(String(value ?? ''));
  } catch {
    return String(value ?? '');
  }
};

export const normalizeCategoryValue = (value) =>
  safelyDecode(value)
    .trim()
    .toLowerCase()
    .replace(/_/g, ' ')
    .replace(/\s+/g, ' ');

export const slugifyCategory = (value) =>
  normalizeCategoryValue(value)
    .replace(/&/g, ' and ')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

const titleCase = (value) =>
  normalizeCategoryValue(value)
    .split(' ')
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');

export const CATEGORY_META = CATEGORY_DEFINITIONS.map((item) => ({ ...item }));

export const resolveCategoryMeta = (input) => {
  const decoded = safelyDecode(input).trim().toLowerCase();
  const normalizedValue = normalizeCategoryValue(input);

  const exactSlugMatch = CATEGORY_DEFINITIONS.find(
    (item) => item.slug === decoded
  );

  if (exactSlugMatch) {
    return { ...exactSlugMatch };
  }

  const exactValueMatch = CATEGORY_DEFINITIONS.find(
    (item) => item.value === normalizedValue
  );

  if (exactValueMatch) {
    return { ...exactValueMatch };
  }

  const valueFromSlug = normalizeCategoryValue(decoded.replace(/-/g, ' '));
  const slugValueMatch = CATEGORY_DEFINITIONS.find(
    (item) => item.value === valueFromSlug
  );

  if (slugValueMatch) {
    return { ...slugValueMatch };
  }

  const fallbackValue = valueFromSlug || normalizedValue || 'business';

  return {
    value: fallbackValue,
    slug: slugifyCategory(fallbackValue) || 'business',
    label: titleCase(fallbackValue) || 'Businesses',
    icon: '🏪',
  };
};

export const categoryUrl = (input) => {
  const meta = resolveCategoryMeta(input);
  return `/categories/${meta.slug}`;
};

export default CATEGORY_META;
